import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';
import { Grid } from '@mui/material';
import { loginWithSSO, loginWithSSOCallback, signUpWithSSO, signUpWithSSOCallback } from 'state/modules/auth';
import FacebookButton from 'components/Buttons/FacebookButton';
import GoogleButton from 'components/Buttons/GoogleButton';
import { getLocalStorageItem } from 'utils/webStorage';
import { localStorageKeys } from 'utils/constants';
import usePushSignUp from 'hooks/router/usePushSignUp';

const SingleSignOn = ({ signUp }) => {
  const dispatch = useDispatch();
  const authenticated = useSelector(state => state.auth.authenticated);
  const ssoProfile = useSelector(state => state.auth.ssoProfile);
  const [searchParams] = useSearchParams();
  const pushSignUp = usePushSignUp({ form: true, keepQueries: true });

  const keepSession = getLocalStorageItem(localStorageKeys.keepSession) || false;
  const provider = searchParams.get('provider');
  const code = searchParams.get('code');

  useEffect(() => {
    if (provider && code && !authenticated) {
      const actionCallback = signUp ? signUpWithSSOCallback(provider, code) : loginWithSSOCallback(provider, code, keepSession);
      dispatch(actionCallback);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // Load the Sign Up Form when an SSO Profile is available but hasn't authenticated
    if (!authenticated && ssoProfile) {
      pushSignUp();
    }
  }, [authenticated, ssoProfile, pushSignUp]);

  const handleStartSignOn = provider => {
    const action = signUp ? signUpWithSSO(provider) : loginWithSSO(provider, '', keepSession);
    dispatch(action);
  };

  const handleFacebookClick = () => handleStartSignOn('facebook');

  const handleGoogleClick = () => handleStartSignOn('google');

  return (
    <Grid container spacing={2}>
      <Grid size={6}>
        <FacebookButton onClick={handleFacebookClick} />
      </Grid>
      <Grid size={6}>
        <GoogleButton onClick={handleGoogleClick} />
      </Grid>
    </Grid>
  );
};

SingleSignOn.propTypes = {
  signUp: PropTypes.bool,
};

export default SingleSignOn;
